import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

import { MarketerUsersDashboard } from '../../../features/marketer-users'
import { MarketerUsersDetail } from '../../../features/marketer-users/components/detail'
import { USERS_COMBOS_IDS } from '../constants'
import { useCombos } from '../../../features/combos'

export const MarketerUsersPage = ({ classes = {} }) => {
  useCombos(USERS_COMBOS_IDS)

  return (
    <Routes>
      <Route exact path="" element={<MarketerUsersDashboard />} />
      <Route exact path=":userId" element={<MarketerUsersDetail />} />
      <Route path="*" element={<Navigate to="" replace />} />
    </Routes>
  )
}
